import { MAX_VARIANT_QUANTITY } from './constants';

export const isMaxVariantQuantity = (variantsQuantity: number) => {
    return variantsQuantity >= MAX_VARIANT_QUANTITY;
};
